import { Outlet } from 'react-router-dom';

function ApplianceManagementLayout() {
	return <Outlet />;
}

export default ApplianceManagementLayout;
